import _ from "lodash";
import React from "react";
import classes from "./AddNoteDialogue.scss";
import I18nHOC from "UIComponents/I18nHOC";
import RichTextEditor from "UIComponents/RichTextEditor";
import { colors } from "Constants";
import { generateRandomId, isEmptyHtml } from "Utils";
import { Button, DSProvider, Modal } from "@toddle-edu/ds-web";

const MODAL_Z_INDEX = 1100;
const DEFAULT_MODAL_DIMENSIONS = {
  height: "680px",
  width: "598px",
};

const DEFAULT_MODAL_STYLES = {
  header: {},
  body: {},
  footer: {},
};

class AddNoteDialogue extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      noteValue: { description: _.get(props, "note.title", "") },
      mode: _.get(props, "mode", "edit"),
    };
  }

  saveNote = () => {
    const { saveNote, onClose } = this.props;

    const { noteValue } = this.state;

    saveNote({
      note: _.get(noteValue, "description", ""),
      id: generateRandomId(),
    });

    onClose();
  };

  updateNote = val => {
    this.setState({ noteValue: val });
  };

  updateMode = val => {
    this.setState({ mode: val });
  };

  render() {
    const {
      t,
      onClose,
      note,
      testId = "addNoteDialogue",
      showLexicalRTE = true,
      customHeader,
      customSaveNoteButtonText,
      dsVersion: _dsVersion,
      isGlobalHeaderOnMultipleScreensEnabled,
      modalDimensions = DEFAULT_MODAL_DIMENSIONS,
      modalStyles = DEFAULT_MODAL_STYLES,
      hasSeparator = true,
    } = this.props;
    const { noteValue, mode } = this.state;
    const isModeAdd = mode === "add";
    const isImportedFromOtherOrg = _.get(note, "isImported", false);
    const dsVersion =
      _dsVersion || isGlobalHeaderOnMultipleScreensEnabled ? "2.0" : "1.0";

    const styles = {
      content: {
        color: colors.neutral400,
        fontSize: "1.2rem",
      },
    };

    let modalHeader = customHeader,
      saveNoteButtonText = customSaveNoteButtonText;

    if (_.isEmpty(modalHeader)) {
      if (isModeAdd) {
        modalHeader = t("common:add_note");
      } else {
        modalHeader =
          mode === "VIEW" || mode == "VIEW_ONLY"
            ? t("common:note")
            : t("common:edit_note");
      }
    }

    if (_.isEmpty(saveNoteButtonText)) {
      saveNoteButtonText = isModeAdd
        ? t("common:add")
        : t("common:save_changes");
    }

    return (
      <Modal
        isOpen
        onClose={onClose}
        width={modalDimensions.width}
        height={modalDimensions.height}
        dsVersion={dsVersion}
        zIndex={MODAL_Z_INDEX}
      >
        <Modal.Header
          isClosable
          testId={`${testId}-noteModal`}
          style={modalStyles.header}
        >
          {modalHeader}
        </Modal.Header>
        <Modal.Body isScrollable={true} style={modalStyles.body}>
          {mode == "VIEW" || mode === "VIEW_ONLY" ? (
            <div
              className={classes.centerContainer}
              dangerouslySetInnerHTML={{
                __html: noteValue.description,
              }}
            ></div>
          ) : (
            <div className={classes.centerContainer}>
              {/* will be removed once DS adds 2.0 support for equation */}
              <DSProvider dsVersion="1.0">
                <RichTextEditor
                  name="description"
                  testId={`${testId}-noteModal`}
                  width={"100%"}
                  height={400}
                  autoresizeMaxHeight={400}
                  placeholder={t("common:text_placeholder")}
                  updateInputField={this.updateNote}
                  textAreaStyles={styles.content}
                  value={noteValue.description}
                  showLexicalRTE={showLexicalRTE}
                />
              </DSProvider>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer hasSeparator={hasSeparator} style={modalStyles.footer}>
          {mode != "VIEW_ONLY" ? (
            <div className={classes.footer}>
              {mode == "VIEW" && !isImportedFromOtherOrg ? (
                <Button
                  dsVersion={dsVersion}
                  type="fill"
                  size="medium"
                  variant="progressive"
                  testId={`${testId}-noteModal-edit`}
                  onClick={() => this.updateMode("EDIT")}
                >
                  {t("common:edit")}
                </Button>
              ) : null}
              {mode !== "VIEW" ? (
                <>
                  <Button
                    dsVersion={dsVersion}
                    variant={"neutral"}
                    _legacy_variant={"outlined-subtle"}
                    type={"outlined"}
                    size="medium"
                    onClick={onClose}
                    testId={`${testId}-noteModal-discard`}
                    className={classes.discardButton}
                  >
                    {/* we have to show the discard button when we are adding the note for the first time and discard chnages in the edit mode  */}
                    {isModeAdd
                      ? t("common:discard")
                      : t("common:discard_changes")}
                  </Button>
                  <Button
                    dsVersion={dsVersion}
                    size="medium"
                    disabled={isEmptyHtml(_.get(noteValue, "description", ""))}
                    onClick={this.saveNote}
                    testId={`${testId}-noteModal-submit`}
                    variant={"progressive"}
                    type={"fill"}
                    shortcut={{
                      code: "Enter",
                      shiftKey: true,
                    }}
                  >
                    {saveNoteButtonText}
                  </Button>
                </>
              ) : null}
            </div>
          ) : null}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default I18nHOC({ resource: ["common"] })(AddNoteDialogue);
